import React from "react";
import "./Footer.css";

const Footer = ({
  openModal,
  currentName = "",
  currentIndex = 0,
  total = 1,
  onPrev,
  onNext,
}) => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="brand-logo">K•L + dizajn.&copy;</div>
        <div className="restaurant-nav">
          <button
            className="restaurant-nav-button"
            onClick={onPrev}
            aria-label="Poprzednia restauracja"
            disabled={currentIndex === 0}
          >
            &lsaquo;
          </button>
          <span className="restaurant-name">{currentName}</span>
          <button
            className="restaurant-nav-button"
            onClick={onNext}
            aria-label="Następna restauracja"
            disabled={currentIndex >= total - 1}
          >
            &rsaquo;
          </button>
        </div>
        <ul className="footer-menu">
          <li>
            <button onClick={openModal} className="footer-button">
              Dokumenty
            </button>
          </li>
        </ul>
      </div>
    </footer>
  );
};

export default Footer;
